import React from 'react';
import actionTypes from 'constants/actionTypes';
const { SigningContractView } = require('routes/formsView/SigningContractView/SigningContractView');
import Immutable from 'immutable';

const { PersonalDataView } = require('routes/formsView/PersonalDataView/PersonalDataView');
const { PersonalDataClientView } = require('routes/formsView/personalDataClientView');
import { OTPTransferView } from 'routes/formsView/OTPTransferView/OTPTransferView';
import { ProfessionalDataView } from 'routes/formsView/ProfessionalDataView/ProfessionalDataViewContainer';
import { IdentityVerificationView } from 'routes/formsView/IdentityVerificationView/IdentityVerificationView';
import { DocumentationView } from 'routes/formsView/DocumentationView/DocumentationView';
import { ConfigCardDataView } from 'routes/formsView/configCardDataView';
import { SuitabilityTestView } from 'routes/formsView/suitabilityTestView';
import { InvestmentPlanView } from 'routes/formsView/investmentPlanView';
import { GbiInvestmentView } from 'routes/formsView/gbiInvestmentView';
import { CreditCardConfigurationView } from 'routes/formsView/creditCardConfigurationView';

import {
    DEFAULT_STEPS,
    DEPOSIT_STEPS,
    AUTHORIZED_STEPS,
    CLIENT_STEPS,
    CONFIG_CARD_STEPS,
    ROBO_STEPS,
    CREDIT_CARD_STEPS,
    GBI_STEPS,
    DEPOSIT_VIEW,
    PERSONAL_DATA_VIEW,
    PROFESSIONAL_DATA_VIEW,
    IDENTIFICATION_VIEW,
    SIGNING_CONTRACT_VIEW,
    DOCUMENTATION_VIEW,
    CONFIG_CARD_VIEW,
    CREDIT_CARD_VIEW,
    SUITABILITY_TEST_VIEW,
    GBI_INVESTMENT_VIEW,
    INVESTMENT_PLAN_VIEW,
    OTP_TRANSFER_VIEW,
    PERSONAL_DATA_TITLE_STEP,
    PROFESSIONAL_DATA_TITLE_STEP,
    IDENTIFICATION_TITLE_STEP,
    SIGNING_TITLE_STEP,
    DOCUMENTATION_TITLE_STEP,
    SIGNATURE_KEY_VIEW,
} from 'constants/steps';
import { DesignYourDepositComponent as DesignDepositView } from 'components/designYourDeposit/designYourDepositContainer';
import { generateSignatureKeyStep } from 'reducers/utils/generateStep';
import { OtpContainer } from 'components/newAccountSteps/profileSteps/otpContainer/OtpContainer';

const createStepObject = ({
    key,
    component,
    title,
    active,
    icon,
    available = false,
    previousStep,
    stepName,
    flagControl,
}) => ({
    key,
    component,
    title,
    active,
    finished: false,
    available,
    icon,
    previousStep,
    stepName,
    flagControl,
});

const defaultSteps = [
    {
        ...createStepObject({
            key: 1,
            component: () => <PersonalDataView />,
            active: true,
            available: true,
            icon: 'evelope',
            title: PERSONAL_DATA_TITLE_STEP,
            previousStep: 0,
            stepName: PERSONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 2,
            component: () => <ProfessionalDataView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: PERSONAL_DATA_VIEW,
            stepName: PROFESSIONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 3,
            component: () => <IdentityVerificationView />,
            active: false,
            icon: 'identity',
            title: IDENTIFICATION_TITLE_STEP,
            previousStep: PROFESSIONAL_DATA_VIEW,
            stepName: IDENTIFICATION_VIEW,
        }),
    },
    {
        ...createStepObject({
            ...generateSignatureKeyStep({ key: 4, previousStep: IDENTIFICATION_VIEW }),
        }),
    },
    {
        ...createStepObject({
            key: 5,
            component: () => <SigningContractView />,
            active: false,
            icon: 'pen',
            title: SIGNING_TITLE_STEP,
            previousStep: SIGNATURE_KEY_VIEW,
            stepName: SIGNING_CONTRACT_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 6,
            component: () => <DocumentationView />,
            active: false,
            icon: 'document',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: SIGNING_CONTRACT_VIEW,
            stepName: DOCUMENTATION_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 7,
            component: () => <OtpContainer />,
            active: false,
            icon: 'identity',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: DOCUMENTATION_VIEW,
            stepName: OTP_TRANSFER_VIEW,
        }),
    },
];

const depositSteps = [
    {
        ...createStepObject({
            key: 1,
            component: () => <PersonalDataView />,
            active: true,
            available: true,
            icon: 'evelope',
            title: PERSONAL_DATA_TITLE_STEP,
            previousStep: 0,
            stepName: PERSONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 2,
            component: () => <DesignDepositView />,
            active: true,
            available: true,
            icon: 'evelope',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: 1,
            stepName: DEPOSIT_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 3,
            component: () => <ProfessionalDataView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: 2,
            stepName: PROFESSIONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 4,
            component: () => <IdentityVerificationView />,
            active: false,
            icon: 'identity',
            title: IDENTIFICATION_TITLE_STEP,
            previousStep: PROFESSIONAL_DATA_VIEW,
            stepName: IDENTIFICATION_VIEW,
        }),
    },
    {
        ...createStepObject({
            ...generateSignatureKeyStep({ key: 5, previousStep: IDENTIFICATION_VIEW }),
        }),
    },
    {
        ...createStepObject({
            key: 6,
            component: () => <SigningContractView />,
            active: false,
            icon: 'pen',
            title: SIGNING_TITLE_STEP,
            previousStep: SIGNATURE_KEY_VIEW,
            stepName: SIGNING_CONTRACT_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 7,
            component: () => <DocumentationView />,
            active: false,
            icon: 'document',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: SIGNING_CONTRACT_VIEW,
            stepName: DOCUMENTATION_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 8,
            component: () => <OtpContainer />,
            active: false,
            icon: 'identity',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: DOCUMENTATION_VIEW,
            stepName: OTP_TRANSFER_VIEW,
        }),
    },
];

const authorizedSteps = [
    {
        ...createStepObject({
            key: 1,
            component: () => <PersonalDataView />,
            active: true,
            available: true,
            icon: 'evelope',
            title: PERSONAL_DATA_TITLE_STEP,
            previousStep: 0,
            stepName: PERSONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 2,
            component: () => <ProfessionalDataView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: PERSONAL_DATA_VIEW,
            stepName: PROFESSIONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            ...generateSignatureKeyStep({ key: 3, previousStep: PERSONAL_DATA_VIEW }),
        }),
    },
    {
        ...createStepObject({
            key: 4,
            component: () => <SigningContractView />,
            active: false,
            icon: 'pen',
            title: SIGNING_TITLE_STEP,
            previousStep: SIGNATURE_KEY_VIEW,
            stepName: SIGNING_CONTRACT_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 5,
            component: () => <DocumentationView />,
            active: false,
            icon: 'document',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: SIGNING_CONTRACT_VIEW,
            stepName: DOCUMENTATION_VIEW,
        }),
    },
];

const clientSteps = [
    {
        ...createStepObject({
            key: 1,
            component: () => <PersonalDataClientView />,
            active: true,
            available: true,
            icon: 'evelope',
            title: PERSONAL_DATA_TITLE_STEP,
            previousStep: 0,
            stepName: PERSONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 2,
            component: () => <ProfessionalDataView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: PERSONAL_DATA_VIEW,
            stepName: PROFESSIONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 3,
            component: () => <SigningContractView />,
            active: false,
            icon: 'pen',
            title: SIGNING_TITLE_STEP,
            previousStep: PROFESSIONAL_DATA_VIEW,
            stepName: SIGNING_CONTRACT_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 4,
            component: () => <DocumentationView />,
            active: false,
            icon: 'document',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: SIGNING_CONTRACT_VIEW,
            stepName: DOCUMENTATION_VIEW,
        }),
    },
];

const configCardSteps = [
    {
        ...createStepObject({
            key: 1,
            component: () => <PersonalDataView />,
            active: true,
            available: true,
            icon: 'evelope',
            title: PERSONAL_DATA_TITLE_STEP,
            previousStep: 0,
            stepName: PERSONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 2,
            component: () => <ConfigCardDataView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: PERSONAL_DATA_VIEW,
            stepName: CONFIG_CARD_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 3,
            component: () => <ProfessionalDataView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: CONFIG_CARD_VIEW,
            stepName: PROFESSIONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 4,
            component: () => <IdentityVerificationView />,
            active: false,
            icon: 'identity',
            title: IDENTIFICATION_TITLE_STEP,
            previousStep: PROFESSIONAL_DATA_VIEW,
            stepName: IDENTIFICATION_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 5,
            component: () => <SigningContractView />,
            active: false,
            icon: 'pen',
            title: SIGNING_TITLE_STEP,
            previousStep: IDENTIFICATION_VIEW,
            stepName: SIGNING_CONTRACT_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 6,
            component: () => <DocumentationView />,
            active: false,
            icon: 'document',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: SIGNING_CONTRACT_VIEW,
            stepName: DOCUMENTATION_VIEW,
        }),
    },
];

const roboSteps = [
    {
        ...createStepObject({
            key: 1,
            component: () => <PersonalDataView />,
            active: true,
            available: true,
            icon: 'evelope',
            title: PERSONAL_DATA_TITLE_STEP,
            previousStep: 0,
            stepName: PERSONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 2,
            component: () => <SuitabilityTestView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: PERSONAL_DATA_VIEW,
            stepName: SUITABILITY_TEST_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 3,
            component: () => <InvestmentPlanView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: SUITABILITY_TEST_VIEW,
            stepName: INVESTMENT_PLAN_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 4,
            component: () => <ProfessionalDataView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: INVESTMENT_PLAN_VIEW,
            stepName: PROFESSIONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            ...generateSignatureKeyStep({ key: 5, previousStep: PROFESSIONAL_DATA_VIEW }),
        }),
    },
    {
        ...createStepObject({
            key: 6,
            component: () => <SigningContractView />,
            active: false,
            icon: 'pen',
            title: SIGNING_TITLE_STEP,
            previousStep: SIGNATURE_KEY_VIEW,
            stepName: SIGNING_CONTRACT_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 7,
            component: () => <IdentityVerificationView />,
            active: false,
            icon: 'identity',
            title: IDENTIFICATION_TITLE_STEP,
            previousStep: SIGNING_CONTRACT_VIEW,
            stepName: IDENTIFICATION_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 8,
            component: () => <DocumentationView />,
            active: false,
            icon: 'document',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: IDENTIFICATION_VIEW,
            stepName: DOCUMENTATION_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 9,
            component: () => <OtpContainer />,
            active: false,
            icon: 'identity',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: DOCUMENTATION_VIEW,
            stepName: OTP_TRANSFER_VIEW,
        }),
    },
];

const gbiSteps = [
    {
        ...createStepObject({
            key: 1,
            component: () => <PersonalDataView />,
            active: true,
            available: true,
            icon: 'evelope',
            title: PERSONAL_DATA_TITLE_STEP,
            previousStep: 0,
            stepName: PERSONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 2,
            component: () => <GbiInvestmentView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: PERSONAL_DATA_VIEW,
            stepName: GBI_INVESTMENT_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 3,
            component: () => <SuitabilityTestView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: GBI_INVESTMENT_VIEW,
            stepName: SUITABILITY_TEST_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 4,
            component: () => <InvestmentPlanView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: SUITABILITY_TEST_VIEW,
            stepName: INVESTMENT_PLAN_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 5,
            component: () => <ProfessionalDataView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: INVESTMENT_PLAN_VIEW,
            stepName: PROFESSIONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 6,
            component: () => <SigningContractView />,
            active: false,
            icon: 'pen',
            title: SIGNING_TITLE_STEP,
            previousStep: PROFESSIONAL_DATA_VIEW,
            stepName: SIGNING_CONTRACT_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 7,
            component: () => <DocumentationView />,
            active: false,
            icon: 'document',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: SIGNING_CONTRACT_VIEW,
            stepName: DOCUMENTATION_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 8,
            component: () => <OTPTransferView />,
            active: false,
            icon: 'identity',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: DOCUMENTATION_VIEW,
            stepName: OTP_TRANSFER_VIEW,
        }),
    },
];

const creditCardSteps = [
    {
        ...createStepObject({
            key: 1,
            component: () => <PersonalDataView />,
            active: true,
            available: true,
            icon: 'evelope',
            title: PERSONAL_DATA_TITLE_STEP,
            previousStep: 0,
            stepName: PERSONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 2,
            component: () => <ProfessionalDataView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: PERSONAL_DATA_VIEW,
            stepName: PROFESSIONAL_DATA_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 3,
            component: () => <IdentityVerificationView />,
            active: false,
            icon: 'identity',
            title: IDENTIFICATION_TITLE_STEP,
            previousStep: PROFESSIONAL_DATA_VIEW,
            stepName: IDENTIFICATION_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 4,
            component: () => <CreditCardConfigurationView />,
            active: false,
            icon: 'briefcase',
            title: PROFESSIONAL_DATA_TITLE_STEP,
            previousStep: IDENTIFICATION_VIEW,
            stepName: CREDIT_CARD_VIEW,
        }),
    },
    {
        ...createStepObject({
            ...generateSignatureKeyStep({ key: 5, previousStep: IDENTIFICATION_VIEW }),
        }),
    },
    {
        ...createStepObject({
            key: 6,
            component: () => <SigningContractView />,
            active: false,
            icon: 'pen',
            title: SIGNING_TITLE_STEP,
            previousStep: SIGNATURE_KEY_VIEW,
            stepName: SIGNING_CONTRACT_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 7,
            component: () => <DocumentationView />,
            active: false,
            icon: 'document',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: SIGNING_CONTRACT_VIEW,
            stepName: DOCUMENTATION_VIEW,
        }),
    },
    {
        ...createStepObject({
            key: 8,
            component: () => <OTPTransferView />,
            active: false,
            icon: 'identity',
            title: DOCUMENTATION_TITLE_STEP,
            previousStep: DOCUMENTATION_VIEW,
            stepName: OTP_TRANSFER_VIEW,
        }),
    },
];

const setInitialState = () => {
    const steps = defaultSteps;
    const currentStep = 0;
    const readOnlyForms = false;
    const initialStepComplete = false;
    const welcomeCard = false;
    const minFinalizeStep = 1;
    const wizardSelected = 'defaultSteps';
    const isPreviousStepDisabled = false;

    return Immutable.Map().merge({
        steps,
        currentStep,
        readOnlyForms,
        initialStepComplete,
        welcomeCard,
        minFinalizeStep,
        wizardSelected,
        isPreviousStepDisabled,
    });
};

export const initialState = setInitialState();

export const stepsReducer = (state = initialState, action) => {
    const findStepIndexByViewName = nextStatusViewName => {
        return state.get('steps').findIndex(step => {
            return step.get('stepName') === nextStatusViewName;
        });
    };

    switch (action.type) {
        case actionTypes.FETCH_STEPS:
            return initialState;

        case actionTypes.CHANGE_CURRENT_STEP: {
            const steps = state.get('steps');
            const nextStepIndex = action.data.index;
            const nextStatusViewName = action.data.viewName;
            const viewNameStepIndex = findStepIndexByViewName(nextStatusViewName);
            const stepToUpdateIndex = nextStepIndex ?? viewNameStepIndex;
            const stepsUpdated = steps.update(stepToUpdateIndex, step => {
                return step.merge({
                    active: true,
                });
            });

            return state.merge({
                currentStep: stepToUpdateIndex,
                steps: stepsUpdated,
            });
        }

        case actionTypes.FINALIZE_STEP: {
            const minFinalizeStep = state.get('minFinalizeStep');
            const currentStepIndex = action.data.index ?? findStepIndexByViewName(action.data.viewName);
            const readOnlyForms = currentStepIndex >= minFinalizeStep;

            return state.merge({
                steps: state.get('steps').update(currentStepIndex, step => {
                    return step.merge({
                        finished: action.data.finished,
                    });
                }),
                readOnlyForms,
            });
        }

        case actionTypes.ENABLE_STEP:
            return state.merge({
                steps: state.get('steps').update(action.data.index, step => {
                    return step.merge({
                        available: action.data.available,
                    });
                }),
            });

        case actionTypes.ENABLE_CURRENT_STEP: {
            const currentStep = action.data.index;
            let steps = state.get('steps');
            state.get('steps').forEach((step, index) => {
                if (index === currentStep) {
                    steps = steps.update(index, step => {
                        return step.merge({
                            available: true,
                        });
                    });
                }
            });

            return state.merge({
                steps,
            });
        }
        case actionTypes.DISABLE_FOLLOWING_STEP: {
            const currentStep = action.data.index;
            let available = true;
            let steps = state.get('steps');
            state.get('steps').forEach((step, index) => {
                if (available && currentStep < index) {
                    available = false;
                }

                steps = steps.update(index, step => {
                    return step.merge({
                        available,
                    });
                });
            });

            return state.merge({
                steps,
            });
        }
        case actionTypes.DISABLE_PREVIOUS_STEPS: {
            const currentStep = action.data.index;

            return state.merge({
                steps: state.get('steps').map((step, index) => {
                    const newState = {};

                    if (currentStep > index) {
                        newState.available = false;
                    }

                    return step.merge(newState);
                }),
                isPreviousStepDisabled: true,
            });
        }
        case actionTypes.ENABLE_PREVIOUS_STEPS: {
            const currentStep = action.data.index;

            return state.merge({
                steps: state.get('steps').map((step, index) => {
                    const newState = {};

                    if (currentStep > index) {
                        newState.available = true;
                    }

                    return step.merge(newState);
                }),
                isPreviousStepDisabled: false,
            });
        }
        case actionTypes.ENABLE_FINISHED_STEP: {
            let steps = state.get('steps');
            let nextStep = 0;
            steps.forEach((step, index) => {
                const finished = step.get('finished');

                if (finished) {
                    nextStep = index;
                }

                steps = steps.update(index, step => {
                    return step.merge({
                        available: finished,
                    });
                });
            });

            nextStep++;
            if (steps.size > nextStep) {
                steps = steps.update(nextStep, step => {
                    return step.merge({
                        available: true,
                    });
                });
            }

            return state.merge({
                steps,
            });
        }
        case actionTypes.INITIAL_STEP_COMPLETED:
            return state.merge({
                initialStepComplete: true,
            });

        case actionTypes.SHOW_WELCOME_CARD:
            return state.merge({
                welcomeCard: true,
            });

        case actionTypes.HIDE_WELCOME_CARD:
            return state.merge({
                welcomeCard: false,
            });

        case actionTypes.DEFAULT_STEPS:
            return state.merge({
                steps: defaultSteps,
                wizardSelected: DEFAULT_STEPS,
            });
        case actionTypes.DEPOSIT_STEPS:
            return state.merge({
                steps: depositSteps,
                wizardSelected: DEPOSIT_STEPS,
            });

        case actionTypes.AUTHORIZED_STEPS:
            return state.merge({
                steps: authorizedSteps,
                wizardSelected: AUTHORIZED_STEPS,
            });

        case actionTypes.CLIENT_STEPS:
            return state.merge({
                steps: clientSteps,
                wizardSelected: CLIENT_STEPS,
            });

        case actionTypes.CONFIG_CARD_STEPS:
            return state.merge({
                steps: configCardSteps,
                wizardSelected: CONFIG_CARD_STEPS,
                minFinalizeStep: 2,
            });

        case actionTypes.ROBO_STEPS:
            return state.merge({
                steps: roboSteps,
                wizardSelected: ROBO_STEPS,
            });

        case actionTypes.CREDIT_CARD_STEPS:
            return state.merge({
                steps: creditCardSteps,
                wizardSelected: CREDIT_CARD_STEPS,
            });

        case actionTypes.GBI_STEPS:
            return state.merge({
                steps: gbiSteps,
                wizardSelected: GBI_STEPS,
            });

        case actionTypes.SET_MIN_FINALIZE_STEP: {
            const nextStatusViewName = action.data.viewName;
            const previousStepIndex = nextStatusViewName
                ? findStepIndexByViewName(nextStatusViewName)
                : action.data.index;

            return state.merge({
                minFinalizeStep: previousStepIndex,
            });
        }
        case actionTypes.FINALIZE_STEPS: {
            const steps = state.get('steps');
            const currentStep = action.data.index ?? findStepIndexByViewName(action.data.viewName);
            const updateMinFinalizeStep = state.get('minFinalizeStep');
            const updateReadOnlyForms = currentStep > updateMinFinalizeStep;

            const stepsUpdated = steps.reduce((acc, _, index) => {
                if (index >= currentStep) {
                    return acc;
                }

                return acc.update(index, stepToUpdate => {
                    return stepToUpdate.merge({
                        finished: true,
                    });
                });
            }, steps);

            return state.merge({
                steps: stepsUpdated,
                readOnlyForms: updateReadOnlyForms,
            });
        }
        default:
            return state;
    }
};
